import type { BuildingType, PlanState } from '../reducers/types'

/**
 * Design plan related action types.
 */
export enum PlanActionType {
  CHOOSE_BUILDING_TYPE = 'CHOOSE_BUILDING_TYPE',
  UPDATE_PLAN = 'UPDATE_PLAN',
}

interface UpdatePlanAction {
  type: PlanActionType.UPDATE_PLAN
  payload: Partial<PlanState>
}

interface ChooseBuildingTypeAction {
  type: PlanActionType.CHOOSE_BUILDING_TYPE
  payload: {
    buildingType: BuildingType
  }
}

export type PlanAction =
  | ChooseBuildingTypeAction
  | UpdatePlanAction

export const updatePlan = (planProperties: Partial<PlanState>): PlanAction => ({ type: PlanActionType.UPDATE_PLAN, payload: planProperties })

export const chooseBuildingType = (buildingType: BuildingType): PlanAction => ({
    type: PlanActionType.CHOOSE_BUILDING_TYPE,
    payload: {
      buildingType
    }
  })
